import {FluidGrid, PlaceholderTiles} from '@aboutyou/ui-components';
import React from 'react';
import {TILES_TO_SHOW} from './SimilarProductsQuickViewView';

export const SimilarProductsQuickViewLoading: React.FC = () => {
  return (
    <FluidGrid>
      <PlaceholderTiles amount={TILES_TO_SHOW} />
    </FluidGrid>
  );
};
